/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancelGoodsItem
 */
export interface CancelGoodsItem {
    /**
     * 商品ID
     * @type {number}
     * @memberof CancelGoodsItem
     */
    goodsId?: number;
    /**
     * 商品取消数量
     * @type {number}
     * @memberof CancelGoodsItem
     */
    quantity?: number;
}

/**
 * Check if a given object implements the CancelGoodsItem interface.
 */
export function instanceOfCancelGoodsItem(value: object): value is CancelGoodsItem {
    return true;
}

export function CancelGoodsItemFromJSON(json: any): CancelGoodsItem {
    return CancelGoodsItemFromJSONTyped(json, false);
}

export function CancelGoodsItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelGoodsItem {
    if (json == null) {
        return json;
    }
    return {
        
        'goodsId': json['goodsId'] == null ? undefined : json['goodsId'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
    };
}

export function CancelGoodsItemToJSON(json: any): CancelGoodsItem {
    return CancelGoodsItemToJSONTyped(json, false);
}

export function CancelGoodsItemToJSONTyped(value?: CancelGoodsItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'goodsId': value['goodsId'],
        'quantity': value['quantity'],
    };
}

